export function countNonEmptyKeysExcluding(obj, excludeKeys) {
    return Object.keys(obj)
        .filter(key => !excludeKeys.includes(key) && obj[key] !== "")
        .length;
}